import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

import posthog from "posthog-js";
import { Button } from "./ui/button";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Link from "next/link";

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(true);

  useEffect(() => {
    if (posthog.has_opted_out_capturing() || posthog.has_opted_in_capturing()) {
      setShowBanner(false);
    }
  }, []);

  const acceptCookies = () => {
    posthog.opt_in_capturing();
    setShowBanner(false);
  };

  const declineCookies = () => {
    posthog.opt_out_capturing();
    setShowBanner(false);
  };

  return (
    <>
      {showBanner && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          <div className="fixed bottom-2 left-2 z-1000 w-auto max-w-md">
            <Alert>
              <AlertTitle>Cookies</AlertTitle>
              <AlertDescription>
                <div className="text-balance">
                  We use cookies to analyze site performance and deliver
                  personalized content. By clicking “Agree”, you consent to our
                  Cookie Policy. You may change your settings at any time.
                </div>
                <div className="mt-4 flex w-full items-center justify-between gap-2">
                  <Button variant="outline" asChild>
                    <Link href="/cookies">Cookie Policy</Link>
                  </Button>
                  <div className="flex items-center gap-2">
                    <Button
                      onClick={declineCookies}
                      variant="secondary"
                      size="sm"
                    >
                      Decline
                    </Button>
                    <Button onClick={acceptCookies} size="sm">
                      Agree
                    </Button>
                  </div>
                </div>
              </AlertDescription>
            </Alert>
          </div>
        </motion.div>
      )}
    </>
  );
}
